import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { setPageMeta } from '../utils/seo';
import { HIRE_TRADES } from '../data/hireTrades';
import { ArrowRight } from '@phosphor-icons/react';

const an = (w) => (/^[aeiou]/i.test(w) ? 'an' : 'a');

export default function HireIndex() {
  useEffect(() => {
    window.scrollTo(0, 0);
    setPageMeta({
      title: 'Hire Local Contractors & Trade Pros Near You | ConstructHelp',
      description: 'Find and hire vetted local pros — roofers, plumbers, electricians, painters and more. Compare free quotes and verified reviews, pay safely with escrow.',
      url: `${window.location.origin}/hire`,
    });
  }, []);

  return (
    <div className="min-h-screen bg-[#E8E9EB] dark:bg-[#121212]" data-testid="hire-index-page">
      <div className="bg-neutral-900 border-b-4 border-[#D95800]">
        <div className="max-w-5xl mx-auto px-4 py-12">
          <h1 className="text-4xl sm:text-5xl font-black text-white uppercase leading-tight mb-3">Hire a Trusted Local Pro</h1>
          <p className="text-neutral-300 max-w-2xl">Pick a trade to see typical 2026 pricing, hiring tips, and answers to the questions homeowners ask most — then get free quotes from verified local pros.</p>
        </div>
      </div>
      <div className="max-w-5xl mx-auto px-4 py-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {HIRE_TRADES.map((t) => (
            <Link key={t.slug} to={`/hire/${t.slug}`}
              className="bg-white dark:bg-neutral-800 border-2 border-neutral-900 dark:border-neutral-700 shadow-[3px_3px_0px_#000] hover:-translate-y-0.5 transition-transform overflow-hidden"
              data-testid={`hire-card-${t.slug}`}>
              <img src={`/hire/${t.slug}.jpg`} alt={`${t.trade} residential project`}
                className="w-full h-36 object-cover border-b-2 border-neutral-900" loading="lazy" />
              <div className="p-5">
                <h2 className="font-black uppercase text-neutral-900 dark:text-white">{t.name}</h2>
                <p className="text-xs text-neutral-500 mt-1 mb-3">{t.avgCost}</p>
                <span className="text-sm font-bold text-[#D95800] flex items-center gap-1">Hire {an(t.singular)} {t.singular} <ArrowRight size={14} weight="bold" /></span>
              </div>
            </Link>
          ))}
        </div>
        <div className="mt-10 text-center space-x-6">
          <Link to="/guides" className="font-bold text-[#D95800] underline" data-testid="hire-to-guides-link">Browse all 2026 cost guides →</Link>
          <Link to="/hiring-guides" className="font-bold text-[#D95800] underline" data-testid="hire-to-hiring-guides-link">How to hire safely →</Link>
        </div>
      </div>
    </div>
  );
}
